/*
 * Rennsieger — door-lights story behaviour.
 *
 * Covers the context-aware sticky bar and the ?from= brand context used by the
 * shared collection-story page. Shopify Liquid cannot read query parameters,
 * so brand resolution has to happen here.
 *
 * No dependencies, no browser storage. Every initialiser no-ops when its
 * markup is absent, so this is safe to load site-wide.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------ *
   * ?from= → readable brand
   * ------------------------------------------------------------------ */

  // Marques whose casing cannot be derived by title-casing a handle.
  var MARQUE_CASING = {
    bmw: 'BMW', vw: 'VW', amg: 'AMG', rs: 'RS', gti: 'GTI',
    'mercedes-benz': 'Mercedes-Benz', mercedes: 'Mercedes',
    audi: 'Audi', porsche: 'Porsche', lamborghini: 'Lamborghini',
    ferrari: 'Ferrari', maserati: 'Maserati', bentley: 'Bentley',
    tesla: 'Tesla', toyota: 'Toyota', lexus: 'Lexus', honda: 'Honda',
    ford: 'Ford', jaguar: 'Jaguar', volvo: 'Volvo', mini: 'MINI',
    range: 'Range Rover', land: 'Land Rover'
  };

  function getParam(name) {
    var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
  }

  // "bmw-led-door-lights" -> "BMW". Falls back to a title-cased handle so an
  // unrecognised marque still produces something readable rather than blank.
  function brandFromHandle(handle) {
    if (!handle) return '';
    var cleaned = handle
      .replace(/-?led-?/g, '-')
      .replace(/-?door-?lights?-?/g, '-')
      .replace(/-?projector-?/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-{2,}/g, '-');
    if (!cleaned) return '';

    if (MARQUE_CASING[cleaned]) return MARQUE_CASING[cleaned];

    var first = cleaned.split('-')[0];
    if (MARQUE_CASING[first]) return MARQUE_CASING[first];

    return cleaned.split('-').map(function (w) {
      return w ? w.charAt(0).toUpperCase() + w.slice(1) : w;
    }).join(' ');
  }

  /* ------------------------------------------------------------------ *
   * Sticky bar
   * ------------------------------------------------------------------ */
  function initStickyBar() {
    var bar = document.querySelector('[data-rsg-stickybar]');
    if (!bar) return;
    if (bar.dataset.rsgBound === '1') return;
    bar.dataset.rsgBound = '1';

    var action = bar.querySelector('[data-rsg-stickybar-action]');
    var label = bar.querySelector('[data-rsg-stickybar-label]');
    var mode = bar.getAttribute('data-mode');

    function show() { bar.hidden = false; bar.classList.add('is-visible'); }
    function hide() { bar.classList.remove('is-visible'); }

    if (mode === 'story') {
      // Route back to the product the reader arrived from. Without a param
      // (direct or organic visit) fall back to the collection.
      var from = getParam('from');
      var brand = brandFromHandle(from);

      if (from) {
        action.setAttribute('href', '/products/' + encodeURIComponent(from));
        label.textContent = brand
          ? '← Back to ' + brand + ' door lights'
          : '← Back to door lights';
      } else {
        action.setAttribute('href', bar.getAttribute('data-collection-url') || '/collections/door-lights');
        label.textContent = 'Shop Door Lights';
      }

      // Always available on the story page — the guaranteed one-tap route back
      // to the purchase.
      bar.hidden = false;
      window.requestAnimationFrame(show);
      return;
    }

    if (mode === 'cap') {
      // A wheel centre cap IS the chosen design, so the bar redirects to the caps collection
      // rather than prompting a selection. Slides up once the reader scrolls past the buy area.
      action.setAttribute('href', bar.getAttribute('data-collection-url') || '/collections/wheel-centre-caps');
      bar.hidden = false;
      var onCapScroll = function () { if (window.pageYOffset > 480) { show(); } else { hide(); } };
      window.addEventListener('scroll', onCapScroll, { passive: true });
      onCapScroll();
      return;
    }

    if (mode === 'product') {
      // Reveal only once the variant selector has scrolled out of view: while
      // it is on screen the bar would just point at something already visible.
      var target = document.querySelector(
        'variant-selects, variant-radios, .product-form__input, [data-rsg-variant-anchor]'
      );

      if (!target) { bar.remove(); return; }

      action.setAttribute('href', '#');
      action.addEventListener('click', function (e) {
        e.preventDefault();
        var header = document.querySelector('.rsg-nav');
        var offset = header ? header.getBoundingClientRect().height + 12 : 12;
        var top = window.pageYOffset + target.getBoundingClientRect().top - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
      });

      bar.hidden = false;

      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { hide(); } else { show(); }
          });
        }, { threshold: 0 });
        obs.observe(target);
      } else {
        show();
      }
    }
  }

  /* ------------------------------------------------------------------ *
   * Story page brand context cue
   * ------------------------------------------------------------------ */
  function initStoryContext() {
    var cue = document.querySelector('[data-rsg-story-context]');
    if (!cue) return;

    var from = getParam('from');
    var brand = brandFromHandle(from);
    if (!from || !brand) { cue.hidden = true; return; }

    var nameEl = cue.querySelector('[data-rsg-story-brand]');
    var linkEl = cue.querySelector('[data-rsg-story-link]');
    if (nameEl) nameEl.textContent = brand + ' Door Lights';
    if (linkEl) linkEl.setAttribute('href', '/products/' + encodeURIComponent(from));
    cue.hidden = false;
  }

  /* ------------------------------------------------------------------ *
   * "Read the full story" links carry the product handle through
   * ------------------------------------------------------------------ */
  function initStoryLinks() {
    var links = document.querySelectorAll('[data-rsg-story-cta]');
    Array.prototype.forEach.call(links, function (a) {
      var handle = a.getAttribute('data-product-handle');
      if (!handle) return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('from=') > -1) return;
      a.setAttribute('href', href + (href.indexOf('?') > -1 ? '&' : '?') + 'from=' + encodeURIComponent(handle));
    });
  }

  /* ------------------------------------------------------------------ *
   * Before/after projection comparison
   * ------------------------------------------------------------------ */
  function initCompare() {
    var stages = document.querySelectorAll('[data-rsg-compare]');
    Array.prototype.forEach.call(stages, function (wrap) {
      if (wrap.dataset.rsgBound === '1') return;
      wrap.dataset.rsgBound = '1';

      var stage = wrap.querySelector('.rsg-vs__stage');
      var range = wrap.querySelector('[data-rsg-compare-range]');
      if (!stage || !range) return;

      var capOurs = wrap.querySelector('[data-rsg-cap="ours"]');
      var capTheirs = wrap.querySelector('[data-rsg-cap="theirs"]');

      function apply() {
        var pos = parseFloat(range.value);
        stage.style.setProperty('--pos', pos + '%');

        // Whichever side covers MORE than half the frame lights up. Strictly
        // greater than 50, so a dead-even split leaves both unlit rather than
        // arbitrarily favouring one.
        if (capOurs) capOurs.classList.toggle('is-lit', pos > 50);
        if (capTheirs) capTheirs.classList.toggle('is-lit', pos < 50);
      }

      // The range input is the single source of truth, so keyboard, pointer
      // and touch all drive the same value and stay in sync automatically.
      range.addEventListener('input', apply);
      apply();
    });
  }

  function init() {
    initStickyBar();
    initStoryContext();
    initStoryLinks();
    initCompare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
